import PropTypes from "prop-types";
import React from "react";

import { useDeviceInfo, XLARGE } from "@swa-ui/browser";
import { Layout } from "@swa-ui/core";
import { usePlacementIds } from "@swa-ui/placements";

import { LuvStoryCard } from "../LuvStoryCard";

export const LuvStoriesSection = (props) => {
  const { placement, placementData } = props;
  const placementIds = usePlacementIds(new RegExp(`${placement?.id}.*`));
  const { screenSize } = useDeviceInfo();

  return (
    placementIds.length > 0 && (
      <Layout {...getLayoutProps()}>
        <LuvStoryCard placementIds={placementIds} placementData={placementData} />
      </Layout>
    )
  );

  function getLayoutProps() {
    return {
      bottom: "medium",
      center: screenSize === XLARGE,
      sides: true,
      top: "large",
    };
  }
};

LuvStoriesSection.displayName = "LuvStoriesSection";
LuvStoriesSection.propTypes = {
  /** Object that displays placement content. */
  placement: PropTypes.object,

  /** Additional data to pass to the placement */
  placementData: PropTypes.object,
};
